import { AnalyticsEvent } from './AnalyticsContext';
import {
  SegmentTrackProperties,
  SegmentPageProperties,
} from './AnalyticsProvider.d';

const nodeEnv = process.env.NODE_ENV;
const showAnalyticsConsole = Boolean(
  process.env.NEXT_PUBLIC_DEV_SHOW_ANALYTICS_CONSOLE
);

export function track(
  event: AnalyticsEvent,
  properties: SegmentTrackProperties
): void {
  if (typeof window === 'undefined' || !window.analytics) {
    return; // Analytics is not available
  }

  if (nodeEnv !== 'production' && showAnalyticsConsole) {
    console.info('Segment Track Event:', event, properties);
  }

  window.analytics.track(event, properties);
}

export function page(name: string, properties: SegmentPageProperties): void {
  if (typeof window === 'undefined' || !window.analytics) {
    return; // Analytics is not available
  }

  if (nodeEnv !== 'production' && showAnalyticsConsole) {
    console.info('Segment Page Event:', name, properties);
  }

  window.analytics.page(name, properties);
}
